<template>
	<div class="login">
		<div class="page-container">
			<LoginForm @success="onLogin" @error="onFailure"></LoginForm>
		</div>
	</div>
</template>

<script>
import LoginForm from '../molecules/LoginForm'

export default {
	name: 'Login',
	components: {
		LoginForm,
	},
	data () {
		return {
		}
	},
	created: function ()
	{
		this.$root.$data.appLoading = false;
	},
	beforeRouteLeave (to, from, next)
	{
		// Destroy the redirect (in case we navigated away but come back later and login)
		this.$root.$data.loginRedirect = null;
		next()

	},
	methods: {
		onLogin(success)
		{
			if(this.$root.$data.loginRedirect)
			{
				this.$router.push(this.$root.$data.loginRedirect);
			}
			else if(this.$root.userHasPermission({
				igt: ['SA']
			}))
			{
				this.$router.push({name: 'Dashboard'});
			}
			else
			{
				this.$router.push({name: 'Homepage'});
			}
		},
		onFailure(error)
		{

		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

	@import "src/scss/toolkit";

	$c: ".login";
	#{$c}
	{
		background-color: #F4F4F4;
		padding: { top: rem(192); bottom: rem(160); }
		text-align: center;

		.login-form
		{
			max-width: 416px;
			@include extend(block-center);
			@include extend(bgc-pal--white);
			border: 1px solid palette('divider');
			border-radius: 4px;
			padding: rem(24) rem(48) rem(48);
			box-shadow: 0 4px 8px rgba(0,0,0,0.05);

			&__title
			{
				color: palette('font');
			}

			&__form
			{
				text-align: left;
			}
		}

		&__enquire
		{
			display: inline-block;
			margin-top: rem(48);
			font-size: rem(14);
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/admin/Login.vue